import axios from './httpConfig.js'
//******************ERP对接 -- ERP单据 ******************/
// ERP单据列表
export function GetErpBillList(param) {
	return axios.post('/admin/erp/order/list', param)
}

// 获取erp单据全部明细
export function GetErpBillDetail(param) {
	return axios.post('/admin/erp/item/list', param)
}

// 根据单据id获取单据明细
export function GetErpBillDetailById(param) {
	return axios.post('/admin/erp/order/item/list', param)
} 